module.exports = __webpack_public_path__ + "static/img/jeans2_r.f929451e.webp";